import { render, staticRenderFns } from "./resend-verification.vue?vue&type=template&id=7044a9c6&scoped=true&lang=pug&"
import script from "./resend-verification.vue?vue&type=script&lang=js&"
export * from "./resend-verification.vue?vue&type=script&lang=js&"
import style0 from "./resend-verification.vue?vue&type=style&index=0&id=7044a9c6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7044a9c6",
  null
  
)

export default component.exports